import React from "react";

interface ActiveKidsSummaryRowProps {
  /** What Shopify actually discounted, read from the cart rather than predicted. */
  appliedCents: number;
}

/**
 * The voucher deduction shown above the Total.
 *
 * Display only. The Total already has this amount removed - it comes from the cart's own
 * total, and the discount Function applied the voucher at cart level - so subtracting
 * again here would double-count it.
 *
 * Renders nothing until a race line exists and the Function has run: before that the
 * amount is zero, and a "- $0.00" row reads as a bug rather than as "not yet".
 */
export const ActiveKidsSummaryRow: React.FC<ActiveKidsSummaryRowProps> = ({ appliedCents }) => {
  if (appliedCents <= 0) return null;

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-px-[12px] tw-py-[8px] tw-text-[14px]">
      <span className="tw-text-white tw-font-[400]">Active Kids voucher</span>
      <span className="tw-font-[700] tw-text-[#F609FF] tw-tabular-nums">
        &minus; ${(appliedCents / 100).toFixed(2)}
      </span>
    </div>
  );
};

export default ActiveKidsSummaryRow;
